<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('open_combos')" :icon="'list'"/>
        <div class="open-combos combos mb-primary">
            <div class="card position-relative card-with-shadow pt-2 pb-primary border-0" v-for="(combo, columnIndex) in combo_data" :key="combo.id" :class="columnIndex > 0 ? 'mt-4' : ''">
                <app-overlay-loader v-if="preloader"/>
                <div v-else class="row align-items-center">
                    <div class="col-12">
                        <form ref="form" data-url="/" enctype="multipart/form-data">
                            <div class="combo-header d-flex flex-row">
                                <div class="col-4">
                                    <label for="name" class="col-form-label">
                                        {{ $t('name') }}
                                    </label>
                                    <app-input 
                                        name="name"
                                        type="text"
                                        v-model="combo.name"
                                        :placeholder="$t('name')"
                                        :required="true"/>
                                </div>
                                <div class="col-2">
                                     <label for="name" class="col-form-label">
                                        {{ $t('status') }}
                                    </label>
                                    <app-input 
                                        name="status"
                                        type="select"
                                        v-model="combo.status"
                                        listValueField='name'
                                        :placeholder="$t('status')"
                                        :list="statusesList"
                                        :required="true"/>
                                </div>
                                <div class="col-2">
                                     <label for="name" class="col-form-label">
                                        {{ $t('min_games') }}
                                    </label>
                                    <app-input 
                                        name="min_games"
                                        type="select"
                                        v-model="combo.min_games"
                                        listValueField='value'
                                        :placeholder="$t('min_games')"
                                        :list="minGamesList[combo.id]"
                                        :required="true"/>
                                </div>
                                <div class="col-2">
                                     <label for="name" class="col-form-label">
                                        {{ $t('max_games') }}
                                    </label>
                                    <app-input 
                                        name="max_games"
                                        type="select"
                                        v-model="combo.max_games"
                                        listValueField='value'
                                        :placeholder="$t('max_games')"
                                        :list="maxGamesList[combo.id]"
                                        :required="true"/>
                                </div>
                                <div class="col-2">
                                     <label for="name" class="col-form-label">
                                        {{ $t('min_combos') }}
                                    </label>
                                    <app-input 
                                        name="min_combos"
                                        type="select"
                                        v-model="combo.min_combos"
                                        listValueField='value'
                                        :placeholder="$t('min_combos')"
                                        :list="minCombosList[combo.id]"
                                        :required="true"/>
                                </div>
                            </div>
                            <div class="combo-subheader d-flex flex-row mt-4 pb-3">
                                <div class="col-1">
                                    {{ $t('time') }}
                                </div>
                                <div class="col-1">
                                    {{ $t('sport') }}
                                </div>
                                <div class="col-2">
                                    {{ $t('league') }}
                                </div>
                                <div class="col-2">
                                    {{ $t('name') }}
                                </div>
                                <div class="col-1">
                                    {{ $t('market') }}
                                </div>
                                <div class="col-1">
                                    {{ $t('sub_market') }}
                                </div>
                                <div class="col-1 text-center">
                                    {{ $t('line') }}
                                </div>
                                <div class="col-1 text-center">
                                    {{ $t('odds') }}
                                </div>
                                <div class="col-1 text-center">
                                {{ $t('amount') }}
                                </div>
                                <div class="col-1 text-center">
                                    {{ $t('actions') }}
                                </div>
                            </div>
                            <div class="combo-body">
                                <div class="col-12 d-flex flex-row" v-for="combo_game in combo.games" :key="combo_game.game_id">
                                    <div class="col-1">
                                        <app-input 
                                            name="id"
                                            type="hidden"
                                            v-model="combo_game.id"
                                            :required="true"/>
                                        {{ combo_game.event_start_time }}
                                    </div>
                                    <div class="col-1">
                                        {{ $t(combo_game.sport) }}
                                    </div>
                                    <div class="col-2">
                                        {{ combo_game.league }}
                                    </div>
                                    <div class="col-2">
                                        {{ combo_game.name }}
                                    </div>
                                    <div class="col-1">
                                        {{ $t(combo_game.market) }}
                                    </div>
                                    <div class="col-1">
                                        {{ $t(combo_game.submarket) }}
                                    </div>
                                    <div class="col-1">
                                        <app-input 
                                            v-if="combo_game.market != 'wdw'"
                                            name="line"
                                            type="text"
                                            v-model="combo_game.line"
                                            :placeholder="$t('line')"
                                            :required="true"/>
                                    </div>
                                    <div class="col-1">
                                        <app-input 
                                            name="odds"
                                            type="text"
                                            v-model="combo_game.odds"
                                            :placeholder="$t('odds')"
                                            :required="true"/>
                                    </div>
                                    <div class="col-1">
                                        <app-input 
                                            name="comboAmount"
                                            class="w-100"
                                            type="select"
                                            v-model="combo_game.combo_amount"
                                            listValueField='value'
                                            :placeholder="$t('combo_amount')"
                                            :list="comboAmountList[combo.id]"
                                            :required="true"/>
                                    </div>
                                    <div class="col-1">
                                        <app-input 
                                            name="comboGameNotes"
                                            type="text"
                                            v-model="combo_game.notes"
                                            :placeholder="$t('notes')"
                                            :required="true"/>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="combo-add mt-2">
                            <div class="col-12 d-flex flex-row">
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.time"
                                        type="text"
                                        :placeholder="'YYYY-MM-DD HH:MM:SS'"
                                        :required="false"/>
                                </div>
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.sport"
                                        type="select"
                                        listValueField='name'
                                        :placeholder="$t('sport')"
                                        :list="sportsList"
                                        :required="false"/>
                                </div>
                                <div class="col-2">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.league"
                                        type="text"
                                        :placeholder="$t('league')"
                                        :required="false"/>
                                </div>
                                <div class="col-2">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.name"
                                        type="text"
                                        :placeholder="$t('name')"
                                        :required="false"/>
                                </div>
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.market"
                                        type="select"
                                        listValueField='name'
                                        :list="marketList"
                                        :placeholder="$t('market')"
                                        :required="false"/>
                                </div>
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.submarket"
                                        type="select"
                                        listValueField='name'
                                        :list="submarketList"
                                        :placeholder="$t('sub_market')"
                                        :required="false"/>
                                </div>
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.line"
                                        type="text"
                                        :placeholder="$t('line')"
                                        :required="false"/>
                                </div>
                                <div class="col-1">
                                    <app-input 
                                        class="w-100"
                                        v-model="customGame.odds"
                                        type="text"
                                        :placeholder="$t('odds')"
                                        :required="false"/>
                                </div>
                                <div class="col-2 text-center">
                                    <button class="btn btn-secondary mr-2" @click.prevent="addCustom(combo)">
                                        {{ $t('add') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="combo-footer mt-4 text-right">
                            <button class="btn btn-secondary mr-2" @click.prevent="deleteCombo(combo)">
                                {{ $t('delete') }}
                            </button>
                            <button class="btn btn-secondary mr-2" @click.prevent="save(combo)">
                                {{ $t('save') }}
                            </button>
                            <button class="btn btn-primary mr-3" @click.prevent="submit(combo)">
                                {{ $t('generate') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";
    export default {
        name: "openCombos",
        mixins: [FormMixin],
        data() {
            return {
                preloader: false,
                combo_data: [],
                statusesList: [
                    {id: 'ACTIVE', name: this.$t('active')},
                    {id: 'SAVED', name: this.$t('saved')},
                    {id: 'GENERATED', name: this.$t('generated')},
                    {id: 'CLOSED', name: this.$t('closed')}
                ],
                comboAmountList: [],
                minCombosList: [],
                minGamesList: [],
                maxGamesList: [],
                customGame: {
                    time: "",
                    sport: "football",
                    league: "",
                    name: "",
                    market: "wdw",
                    submarket: "home",
                    line: "", 
                    odds: ""
                },
                sportsList: [
                    {id: 'football', name: this.$t('football')},
                    {id: 'basketball', name: this.$t('basketball')},
                    {id: 'tennis', name: this.$t('tennis')}
                ],
                marketList: [
                    {id: 'wdw', name: this.$t('wdw')},
                    {id: 'asian', name: this.$t('asian_handicap')},
                    {id: 'totals', name: this.$t('totals')}
                ],
                submarketList: [
                    {id: 'home', name: this.$t('home')},
                    {id: 'away', name: this.$t('away')},
                    {id: 'draw', name: this.$t('draw')},
                    {id: 'over', name: this.$t('over')},
                    {id: 'under', name: this.$t('under')}
                ]
            }
        },
        created() {
            this.data();
        },
        methods: {
            data() {
                this.preloader= true;
                let url = actions.OPEN_COMBOS_LIST;
                this.axiosGet(url).then(response => {
                    var response_data = response.data;
                    var max_values = 5;
                    this.comboAmountList = [];
                    this.minCombosList = [];
                    this.maxGamesList = [];
                    for (let index = 0; index < response_data.length; ++index) {
                        if (response_data[index].games){
                            var games_amount = response_data[index].games.length;
                            for (let x = 0; x <= games_amount; ++x) {
                                if (!this.comboAmountList[response_data[index].id]){
                                    this.comboAmountList[response_data[index].id] = [];
                                }
                                this.comboAmountList[response_data[index].id].push({id: x, value: x});
                                if (!this.minGamesList[response_data[index].id]){
                                    this.minGamesList[response_data[index].id] = [{id: 0, value: this.$t('auto')}];
                                }
                                if (x > 0){
                                    this.minGamesList[response_data[index].id].push({id: x, value: x});
                                }
                            }

                            var min_count = Math.round(games_amount / 3);
                            var max_count = games_amount;
                            for (let x = min_count; x <= max_count; ++x) {
                                if (!this.maxGamesList[response_data[index].id]){
                                    this.maxGamesList[response_data[index].id] = [{id: 0, value: this.$t('auto')}];
                                }
                                this.maxGamesList[response_data[index].id].push({id: x, value: x});
                            }

                            var min_count = Math.round(games_amount / 2);
                            var max_count = games_amount + min_count;
                            for (let x = min_count; x <= max_count; ++x) {
                                if (!this.minCombosList[response_data[index].id]){
                                    this.minCombosList[response_data[index].id] = [{id: 0, value: this.$t('auto')}];
                                }
                                this.minCombosList[response_data[index].id].push({id: x, value: x});
                            }
                        }
                    }
                    this.combo_data = response_data;
                }).catch(({response}) => {
                }).finally(()=>{
                    this.preloader=false;
                });
            },
            addCustom(combo){
                var formData = new FormData();
                formData.append('combo_id', combo.id);
                formData.append('time', this.customGame.time);
                formData.append('sport', this.customGame.sport);
                formData.append('league', this.customGame.league);
                formData.append('name', this.customGame.name);
                formData.append('market', this.customGame.market);
                formData.append('submarket', this.customGame.submarket);
                formData.append('line', this.customGame.line);
                formData.append('odds', this.customGame.odds);

                this.axiosPost({
                    url: actions.COMBOS_ADD_CUSTOM,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('game_added_to_combo') + "<br/><b>" + name + "</b>");
                        this.customGame = {time: "", sport: "football", league: "", name: "", market: "wdw", submarket: "home", line: "",  odds: ""};
                        this.data();
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message) + "<br/>");
                    }
                });
            },
            beforeSubmit(){
                this.preloader = true;
            },
            save(combo) {
                var formData = new FormData();
                for (const [key, value] of Object.entries(combo)) {
                    if (key == 'games'){
                        formData.append(key, JSON.stringify(value));
                    } else if (key == 'id'){
                        formData.append('combo_id', value);
                    } else {
                        formData.append(key, value);
                    }
                }
                this.axiosPost({
                    url: actions.COMBOS_SAVE,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('combo_data_updated') + "<br/><b>" + name + "</b>");
                        this.data();
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message) + "<br/>");
                    }
                });
            },
            submit(combo) {
                var formData = new FormData();
                for (const [key, value] of Object.entries(combo)) {
                    if (key == 'games'){
                        formData.append(key, JSON.stringify(value));
                    } else if (key == 'id'){
                        formData.append('combo_id', value);
                    } else {
                        formData.append(key, value);
                    }
                }
                this.axiosPost({
                    url: actions.COMBOS_GENERATE,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('combo_generated'));
                    } else if (response.data.status == 2){
                        this.$toastr.w(this.$t('combo_generated_with_errors')  + "<br/>" + this.$t('please_check_parameters'));
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message) + "<br/>");
                    }
                });
            },
            deleteCombo(combo) {
                var formData = new FormData();
                formData.append('combo_id', combo.id);
                formData.append('combo_user_id', combo.user_id);
                this.axiosPost({
                    url: actions.COMBOS_DELETE,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('combo_deleted') + "<br/><b>" + name + "</b>");
                        this.data();
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message) + "<br/>");
                    }
                });
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        }
    }
</script>